import { axiosInstance } from '../common/api';

export const getTaskClassificationList = ({ start, pageSize, filters, globalFilter, sorting, projectId }) => {
  let url = `/task-classification/?`;
  if (pageSize) url += `pageSize=${pageSize}&`;
  else url += `pageSize=all&`;
  if (start) url += `start=${start}&`;
  if (filters) url += `filters=${filters}&`;
  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;
  if (projectId) url += `projectId=${projectId}&`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const createTaskClassification =(payload) => {
  const url = '/task-classification/';
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, payload)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateTaskClassificationById = (payload, id) => {
  const url = `/task-classification/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, payload)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteTaskClassificationById = (id) => {
  const url = `/task-classification/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
